import React from 'react';
import logo from '../../../icons/logo-myjobglasses-white.svg';
import logoSm from '../../../icons/logo-myjobglasses-white-sm.svg';
import LanguageSelector from './components/language-selector/LanguageSelector';

import './Footer.scss';

const Footer = () => (
  <footer className="general-footer">
    <header className="footer-header">
      <div className="branding">
        <img src={logo} alt="My Job Glasses" className="desktop" />
        <img src={logoSm} alt="My Job Glasses" className="mobile" />
        <p>
          &copy;&#32;MyJobGlasses&#32;&nbsp;
          {(new Date()).getFullYear()}
        </p>
      </div>
      <LanguageSelector />
    </header>
  </footer>
);

Footer.propTypes = {
};

export default Footer;
